(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-my-size"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var BOXES = [
      { name:'3.30 × 2.75 × 1" Box',     dims:[3.30,2.75,1.00], price:449,  old:525,  url:'/products/2-75-1-3-30' },
      { name:'3 × 2 × 2" Box',           dims:[3.00,2.00,2.00], price:620,  old:725,  url:'/products/3-2-2' },
      { name:'4 × 2 × 2" Box',           dims:[4.00,2.00,2.00], price:648,  old:760,  url:'/products/4-2-2' },
      { name:'4 × 3 × 2" Box',           dims:[4.00,3.00,2.00], price:633,  old:740,  url:'/products/4-3-2' },
      { name:'4 × 3 × 3" Box',           dims:[4.00,3.00,3.00], price:690,  old:805,  url:'/products/4-3-3' },
      { name:'4 × 4 × 1.5" Box',         dims:[4.00,4.00,1.50], price:748,  old:875,  url:'/products/4-x-4-x-1-5-inch-pack-of-100-pc' },
      { name:'4 × 4 × 2" Box',           dims:[4.00,4.00,2.00], price:885,  old:1035, url:'/products/4-x-4-x-2-inch-pack-of-100-pc' },
      { name:'4 × 4 × 4" Box',           dims:[4.00,4.00,4.00], price:809,  old:945,  url:'/products/4-x-4-x-4-inch-pack-of-100-pc' },
      { name:'4.60 × 3.70 × 1.60" Box',  dims:[4.60,3.70,1.60], price:808,  old:945,  url:'/products/4-60-x-3-70-x-1-60' },
      { name:'4.5 × 1.5 × 6.5" Box',     dims:[4.50,1.50,6.50], price:885,  old:1035, url:'/products/4-5-x-1-5-x-6-5' },
      { name:'4 × 1.5 × 5" Box',         dims:[4.00,1.50,5.00], price:785,  old:920,  url:'/products/4-x-1-5-x-5-inch-pack-of-100-pc' },
      { name:'4 × 2 × 7" Box',           dims:[4.00,2.00,7.00], price:952,  old:1115, url:'/products/4-x-2-x-7-inch-pack-of-100-pc' },
      { name:'4.25 × 3 × 10" Box',       dims:[4.25,3.00,10.00], price:1323, old:1545, url:'/products/4-25-x-3-x-10-inch-pack-of-100-pc' },
      { name:'4 × 3 × 12" Box',          dims:[4.00,3.00,12.00], price:1115, old:1305, url:'/products/12-x-4-x3' },
      { name:'5 × 2 × 2" Box',           dims:[5.00,2.00,2.00], price:677,  old:790,  url:'/products/5-2-2' },
      { name:'5 × 3 × 2" Box',           dims:[5.00,3.00,2.00], price:637,  old:895,  url:'/products/5-3-2' },
      { name:'5 × 3 × 3" Box',           dims:[5.00,3.00,3.00], price:694,  old:810,  url:'/products/5-3-3' },
      { name:'5 × 4 × 2" Box',           dims:[5.00,4.00,2.00], price:732,  old:855,  url:'/products/5-4-2' },
      { name:'5 × 4 × 3" Box',           dims:[5.00,4.00,3.00], price:796,  old:930,  url:'/products/5-4-3' },
      { name:'5 × 4 × 3.5" Box',         dims:[5.00,4.00,3.50], price:828,  old:970,  url:'/products/5-x-4-x-3-5' },
      { name:'5 × 4 × 4" Box',           dims:[5.00,4.00,4.00], price:860,  old:1000, url:'/products/5-4-4' },
      { name:'5 × 5 × 2" Box',           dims:[5.00,5.00,2.00], price:1108, old:1295, url:'/products/5-x-5-x-2-inch-pack-of-100-pc' },
      { name:'5 × 5 × 5" Box',           dims:[5.00,5.00,5.00], price:1051, old:1975, url:'/products/5-x-5-x-5-inch-pack-of-100-pc' },
      { name:'5 × 5 × 8" Box',           dims:[5.00,5.00,8.00], price:1261, old:1475, url:'/products/8-x-5-x-5-inch-pack-of-100-pc' },
      { name:'5.5 × 5.5 × 1.5" Box',     dims:[5.50,5.50,1.50], price:1010, old:1180, url:'/products/5-5-x-5-5-x-1-5-inch-pack-of-100-pc-copy' },
      { name:'5.5 × 5.5 × 3.5" Box',     dims:[5.50,5.50,3.50], price:1038, old:1215, url:'/products/5-5-x-5-5-x-3-5' },
      { name:'5.5 × 5.5 × 4.5" Box',     dims:[5.50,5.50,4.50], price:1115, old:1305, url:'/products/5-5-x-5-5-x-4-5' },
      { name:'5.5 × 5.5 × 6" Box',       dims:[5.50,5.50,6.00], price:1229, old:1440, url:'/products/5-5-x-5-5-x-6' },
      { name:'5.25 × 4.25 × 3.5" Box',   dims:[5.25,4.25,3.50], price:1656, old:1940, url:'/products/5-25-x-4-25-x-3-5' },
      { name:'5 × 2 × 7" Box',           dims:[5.00,2.00,7.00], price:1064, old:1245, url:'/products/5-x-2-x-7' },
      { name:'5.25 × 3 × 7" Box',        dims:[5.25,3.00,7.00], price:1523, old:1780, url:'/products/7-x-5-25-x-3' },
      { name:'6 × 2 × 2" Box',           dims:[6.00,2.00,2.00], price:679,  old:795,  url:'/products/6-2-2' },
      { name:'6 × 3 × 2" Box',           dims:[6.00,3.00,2.00], price:669,  old:785,  url:'/products/6-3-2' },
      { name:'6 × 3 × 3" Box',           dims:[6.00,3.00,3.00], price:732,  old:855,  url:'/products/6-3-3' },
      { name:'6 × 4 × 2" Box',           dims:[6.00,4.00,2.00], price:771,  old:900,  url:'/products/6-4-2' },
      { name:'6 × 4 × 3" Box',           dims:[6.00,4.00,3.00], price:841,  old:984,  url:'/products/6-4-3' },
      { name:'6 × 4 × 4" Box',           dims:[6.00,4.00,4.00], price:911,  old:1065, url:'/products/6-4-4' },
      { name:'6 × 5 × 2" Box',           dims:[6.00,5.00,2.00], price:885,  old:1035, url:'/products/6-5-2' },
      { name:'6 × 5 × 3" Box',           dims:[6.00,5.00,3.00], price:962,  old:1130, url:'/products/6-5-3' },
      { name:'6 × 5 × 4" Box',           dims:[6.00,5.00,4.00], price:1038, old:1215, url:'/products/6-5-4' },
      { name:'6 × 5 × 5" Box',           dims:[6.00,5.00,5.00], price:1115, old:1305, url:'/products/6-5-5' },
      { name:'6 × 6 × 2" Box',           dims:[6.00,6.00,2.00], price:1258, old:1470, url:'/products/6-x-6-x-2-inch-pack-of-100-pc' },
      { name:'6.5 × 3.5 × 2.5" Box',     dims:[6.50,3.50,2.50], price:1268, old:1485, url:'/products/6-5-x-3-5-x-2-5' },
      { name:'6.5 × 4.25 × 4.25" Box',   dims:[6.50,4.25,4.25], price:987,  old:1155, url:'/products/6-5-x-4-25-x-4-25' },
      { name:'6.5 × 5 × 4" Box',         dims:[6.50,5.00,4.00], price:2072, old:2425, url:'/products/6-5-x-5-x-4' },
      { name:'6.5 × 5.5 × 4" Box',       dims:[6.50,5.50,4.00], price:1137, old:1330, url:'/products/6-5-x-5-5-x-4' },
      { name:'6.25 × 6.25 × 5.10" Box',  dims:[6.25,6.25,5.10], price:1327, old:1550, url:'/products/6-25-x-6-25-x-5-10' },
      { name:'6 × 1.5 × 5" Box',         dims:[6.00,1.50,5.00], price:946,  old:1110, url:'/products/6-x-1-5-x-5' },
      { name:'7 × 2 × 2" Box',           dims:[7.00,2.00,2.00], price:705,  old:825,  url:'/products/7-2-2' },
      { name:'7 × 3 × 2" Box',           dims:[7.00,3.00,2.00], price:700,  old:820,  url:'/products/7-3-2' },
      { name:'7 × 3 × 2.75" Box',        dims:[7.00,3.00,2.75], price:1273, old:1490, url:'/products/7-x-3-x-2-75' },
      { name:'7 × 3 × 3" Box',           dims:[7.00,3.00,3.00], price:771,  old:900,  url:'/products/7-3-3' },
      { name:'7 × 4 × 2" Box',           dims:[7.00,4.00,2.00], price:809,  old:945,  url:'/products/7-4-2' },
      { name:'7 × 4 × 3" Box',           dims:[7.00,4.00,3.00], price:1379, old:1610, url:'/products/7-x-4-x-3-inch-pack-of-100-pc' },
      { name:'7 × 4 × 3.5" Box',         dims:[7.00,4.00,3.50], price:924,  old:1080, url:'/products/7-4-3-5' },
      { name:'7 × 4 × 4" Box',           dims:[7.00,4.00,4.00], price:962,  old:1125, url:'/products/7-4-4' },
      { name:'7 × 5 × 2" Box',           dims:[7.00,5.00,2.00], price:1115, old:1305, url:'/products/7-x-5-x-2-inch-pack-of-100-pc' },
      { name:'7 × 5 × 2.5" Box',         dims:[7.00,5.00,2.50], price:971,  old:1135, url:'/products/7-5-2-5' },
      { name:'7 × 5 × 3" Box',           dims:[7.00,5.00,3.00], price:1013, old:1185, url:'/products/7-5-3' },
      { name:'7 × 5 × 4" Box',           dims:[7.00,5.00,4.00], price:1096, old:1280, url:'/products/7-5-4' },
      { name:'7 × 5 × 5" Box',           dims:[7.00,5.00,5.00], price:1179, old:1380, url:'/products/7-5-5' },
      { name:'7 × 6 × 1.5" Box',         dims:[7.00,6.00,1.50], price:1131, old:1325, url:'/products/7-x-6-x-1-5-inch-pack-of-100-pc' },
      { name:'7 × 6 × 2" Box',           dims:[7.00,6.00,2.00], price:1064, old:1245, url:'/products/7-6-2' },
      { name:'7 × 6 × 3" Box',           dims:[7.00,6.00,3.00], price:1153, old:1350, url:'/products/7-6-3' },
      { name:'7 × 6 × 4" Box',           dims:[7.00,6.00,4.00], price:1242, old:1455, url:'/products/7-6-4' },
      { name:'7 × 6 × 5" Box',           dims:[7.00,6.00,5.00], price:1331, old:1560, url:'/products/7-6-5' },
      { name:'7 × 6 × 6" Box',           dims:[7.00,6.00,6.00], price:1421, old:1660, url:'/products/7-6-6' },
      { name:'7 × 7 × 2" Box',           dims:[7.00,7.00,2.00], price:1421, old:1660, url:'/products/7-x-7-x-2-inch-pack-of-100-pc' },
      { name:'7 × 7 × 2.5" Box',         dims:[7.00,7.00,2.50], price:1258, old:1470, url:'/products/7-x-7-x-2-5' },
      { name:'7 × 7 × 7" Box',           dims:[7.00,7.00,7.00], price:1688, old:1975, url:'/products/7-x-7-x-7' },
      { name:'7.5 × 7 × 3" Box',         dims:[7.50,7.00,3.00], price:1338, old:1565, url:'/products/7-5-x-7-x-3' },
      { name:'8 × 2 × 2" Box',           dims:[8.00,2.00,2.00], price:730,  old:855,  url:'/products/8-2-2' },
      { name:'8 × 3 × 2" Box',           dims:[8.00,3.00,2.00], price:732,  old:855,  url:'/products/8-3-2' },
      { name:'8 × 3 × 3" Box',           dims:[8.00,3.00,3.00], price:809,  old:945,  url:'/products/8-3-3' },
      { name:'8 × 4 × 2" Box',           dims:[8.00,4.00,2.00], price:847,  old:990,  url:'/products/8-4-2' },
      { name:'8 × 4 × 3" Box',           dims:[8.00,4.00,3.00], price:930,  old:1090, url:'/products/8-4-3' },
      { name:'8 × 4 × 4" Box',           dims:[8.00,4.00,4.00], price:1013, old:1185, url:'/products/8-x-4-x-4' },
      { name:'8 × 5 × 2" Box',           dims:[8.00,5.00,2.00], price:975,  old:1140, url:'/products/8-5-2' },
      { name:'8 × 5 × 2.5" Box',         dims:[8.00,5.00,2.50], price:1019, old:1190, url:'/products/8-5-2-5' },
      { name:'8 × 5 × 3" Box',           dims:[8.00,5.00,3.00], price:1064, old:1245, url:'/products/8-5-3' },
      { name:'8 × 5 × 4" Box',           dims:[8.00,5.00,4.00], price:1153, old:1350, url:'/products/8-x-5-x-4' },
      { name:'8 × 5 × 5" Box',           dims:[8.00,5.00,5.00], price:1242, old:1452, url:'/products/8-5-5' },
      { name:'8 × 6 × 2" Box',           dims:[8.00,6.00,2.00], price:1115, old:1305, url:'/products/8-6-2' },
      { name:'8 × 6 × 3" Box',           dims:[8.00,6.00,3.00], price:1210, old:1415, url:'/products/8-6-3' },
      { name:'8 × 6 × 4" Box',           dims:[8.00,6.00,4.00], price:1306, old:1530, url:'/products/8-6-4' },
      { name:'8 × 6 × 5" Box',           dims:[8.00,6.00,5.00], price:1402, old:1640, url:'/products/8-6-5' },
      { name:'8 × 6 × 6" Box',           dims:[8.00,6.00,6.00], price:1497, old:1750, url:'/products/8-6-6' },
      { name:'8 × 7 × 2" Box',           dims:[8.00,7.00,2.00], price:1268, old:1485, url:'/products/8-7-2' },
      { name:'8 × 7 × 3" Box',           dims:[8.00,7.00,3.00], price:1370, old:1600, url:'/products/8-7-3' },
      { name:'8 × 7 × 4" Box',           dims:[8.00,7.00,4.00], price:1472, old:1722, url:'/products/8-7-4' },
      { name:'8 × 7 × 5" Box',           dims:[8.00,7.00,5.00], price:1574, old:1840, url:'/products/8-7-5' },
      { name:'8 × 7 × 6" Box',           dims:[8.00,7.00,6.00], price:1676, old:1960, url:'/products/8-7-6' },
      { name:'8 × 7 × 7" Box',           dims:[8.00,7.00,7.00], price:1778, old:2080, url:'/products/8-7-7' },
      { name:'8 × 8 × 1.5" Box',         dims:[8.00,8.00,1.50], price:1437, old:1680, url:'/products/8-10-x-1-60-s-8-10' },
      { name:'8 × 3 × 12" Box',          dims:[8.00,3.00,12.00], price:1956, old:2290, url:'/products/8-x-3-x-12' },
      { name:'8.25 × 4 × 10.25" Box',    dims:[8.25,4.00,10.25], price:2157, old:2525, url:'/products/8-25-x-4-x-10-25' },
      { name:'8.25 × 3 × 10.60" Box',    dims:[8.25,3.00,10.60], price:1910, old:2235, url:'/products/8-25-x-3-x-10-60-inch-pack-of-100pc' },
      { name:'8.25 × 2.75 × 10.25" Box', dims:[8.25,2.75,10.25], price:1803, old:2110, url:'/products/8-25-x-2-75-x-10-25' },
      { name:'8 × 1.5 × 6.6" Box',       dims:[8.00,1.50,6.60], price:1220, old:1430, url:'/products/8-x-1-5-x-6-60' },
      { name:'9 × 2 × 2" Box',           dims:[9.00,2.00,2.00], price:756,  old:885,  url:'/products/9-2-2' },
      { name:'9 × 3 × 2" Box',           dims:[9.00,3.00,2.00], price:764,  old:895,  url:'/products/9-3-2' },
      { name:'9 × 3 × 3" Box',           dims:[9.00,3.00,3.00], price:847,  old:990,  url:'/products/9-3-3' },
      { name:'9 × 4 × 2" Box',           dims:[9.00,4.00,2.00], price:885,  old:1035, url:'/products/9-4-2' },
      { name:'9 × 4 × 3" Box',           dims:[9.00,4.00,3.00], price:975,  old:1140, url:'/products/9-4-3' },
      { name:'9 × 4 × 4" Box',           dims:[9.00,4.00,4.00], price:1064, old:1244, url:'/products/9-4-4' },
      { name:'9 × 5 × 2" Box',           dims:[9.00,5.00,2.00], price:1019, old:1190, url:'/products/9-5-2' },
      { name:'9 × 5 × 3" Box',           dims:[9.00,5.00,3.00], price:1115, old:1305, url:'/products/9-5-3' },
      { name:'9 × 5 × 4" Box',           dims:[9.00,5.00,4.00], price:1210, old:1415, url:'/products/9-5-4' },
      { name:'9 × 5 × 5" Box',           dims:[9.00,5.00,5.00], price:1306, old:1530, url:'/products/9-5-5' },
      { name:'9 × 6 × 2" Box',           dims:[9.00,6.00,2.00], price:1325, old:1550, url:'/products/9-x-6-x-2-inch-pack-of-100-pc' },
      { name:'9 × 6 × 3" Box',           dims:[9.00,6.00,3.00], price:1755, old:2050, url:'/products/9-x-6-x-3-inch-pack-of-100-pc' },
      { name:'9 × 6 × 4" Box',           dims:[9.00,6.00,4.00], price:2262, old:2645, url:'/products/9-x-6-x-4-inch-pack-of-100-pc' },
      { name:'9 × 6 × 4.5" Box',         dims:[9.00,6.00,4.50], price:1421, old:1660, url:'/products/9-6-4-5' },
      { name:'9 × 6.5 × 2.5" Box',       dims:[9.00,6.50,2.50], price:1296, old:1515, url:'/products/9-6-5-2-5' },
      { name:'9 × 7 × 2" Box',           dims:[9.00,7.00,2.00], price:1433, old:1675, url:'/products/9-x-7-x-2-inch-pack-of-100-pc' },
      { name:'9 × 7 × 3" Box',           dims:[9.00,7.00,3.00], price:1889, old:2210, url:'/products/9-x-7-x-3-inch-pack-of-100-pc' },
      { name:'9 × 7 × 4" Box',           dims:[9.00,7.00,4.00], price:2421, old:2830, url:'/products/9-x-7-x-4-inch-pack-of-100-pc' },
      { name:'9 × 8 × 8" Box',           dims:[9.00,8.00,8.00], price:2185, old:2560, url:'/products/9-x-8-x-8' },
      { name:'9 × 8.25 × 1.60" Box',     dims:[9.00,8.25,1.60], price:1533, old:1795, url:'/products/9-x-1-60-x-8-25' },
      { name:'9 × 1.5 × 11" Box',        dims:[9.00,1.50,11.00], price:1596, old:1870, url:'/products/9-x-1-5-x-11' },
      { name:'9 × 2.5 × 9" Box',         dims:[9.00,2.50,9.00], price:1664, old:1945, url:'/products/9-x-2-5-9-inch-pack-of-100-pc' },
      { name:'9.75 × 7.5 × 1.60" Box',   dims:[9.75,7.50,1.60], price:1412, old:1650, url:'/products/9-75-x-1-60-x-7-5' },
      { name:'10 × 3 × 2" Box',          dims:[10.00,3.00,2.00], price:1038, old:1215, url:'/products/10-x-3-x-2-inch-pack-of-100-pc' },
      { name:'10 × 4 × 2" Box',          dims:[10.00,4.00,2.00], price:1153, old:1350, url:'/products/10-x-4-x-2-inch-pack-of-100-pc' },
      { name:'10 × 4 × 3" Box',          dims:[10.00,4.00,3.00], price:1542, old:1805, url:'/products/10-x-4-x-3-inch-pack-of-100-pc' },
      { name:'10 × 4.5 × 4" Box',        dims:[10.00,4.50,4.00], price:1190, old:1390, url:'/products/10-x-4-5-x-4' },
      { name:'10 × 5 × 2" Box',          dims:[10.00,5.00,2.00], price:1268, old:1485, url:'/products/10-x-5-x-2-inch-pack-of-100-pc' },
      { name:'10 × 5 × 3" Box',          dims:[10.00,5.00,3.00], price:1682, old:1970, url:'/products/10-x-5-x-3-inch-pack-of-100-pc' },
      { name:'10 × 5 × 4" Box',          dims:[10.00,5.00,4.00], price:2173, old:2540, url:'/products/10-x-5-x-4-inch-pack-of-100-pc' },
      { name:'10 × 6 × 2" Box',          dims:[10.00,6.00,2.00], price:1382, old:1615, url:'/products/10-x-6-x-2-inch-pack-of-100-pc' },
      { name:'10 × 6 × 3" Box',          dims:[10.00,6.00,3.00], price:1822, old:2130, url:'/products/10-x-6-x-3-inch-pack-of-100-pc' },
      { name:'10 × 6 × 4" Box',          dims:[10.00,6.00,4.00], price:2338, old:2735, url:'/products/10-x-6-x-4-inch-pack-of-100-pc' },
      { name:'10 × 7 × 2" Box',          dims:[10.00,7.00,2.00], price:1497, old:1750, url:'/products/10-x-7-x-2-inch-pack-of-100-pc' },
      { name:'10 × 7 × 3" Box',          dims:[10.00,7.00,3.00], price:1962, old:2295, url:'/products/10-x-7-x-3-inch-pack-of-100-pc' },
      { name:'10 × 7 × 4" Box',          dims:[10.00,7.00,4.00], price:2504, old:2930, url:'/products/10-x-7-x-4-inch-pack-of-100-pc' },
      { name:'10 × 8 × 2" Box',          dims:[10.00,8.00,2.00], price:1612, old:1885, url:'/products/10-x-8-x-2-inch-pack-of-100-pc' },
      { name:'10 × 8 × 3" Box',          dims:[10.00,8.00,3.00], price:2103, old:2460, url:'/products/10-x-8-x-3-inch-pack-of-100-pc' },
      { name:'10 × 8 × 4" Box',          dims:[10.00,8.00,4.00], price:2670, old:3125, url:'/products/10-x-8-x-4-inch-pack-of-100-pc' },
      { name:'10 × 9 × 3" Box',          dims:[10.00,9.00,3.00], price:2243, old:2625, url:'/products/10-x-9-x-3-inch-pack-of-100-pc' },
      { name:'10 × 9 × 4" Box',          dims:[10.00,9.00,4.00], price:2836, old:3320, url:'/products/10-x-9-x-4-inch-pack-of-100-pc' },
      { name:'10 × 9.10 × 2.30" Box',    dims:[10.00,9.10,2.30], price:2048, old:2395, url:'/products/10-x-9-10-x-2-30' },
      { name:'10 × 10 × 2" Box',         dims:[10.00,10.00,2.00], price:1985, old:2325, url:'/products/10-x-10-x-2-inch-pack-of-100-pc' },
      { name:'10 × 10 × 3" Box',         dims:[10.00,10.00,3.00], price:2549, old:2980, url:'/products/10-x-10-x-3-inch-pack-of-100-pc' },
      { name:'10 × 2 × 12" Box',         dims:[10.00,2.00,12.00], price:1883, old:2205, url:'/products/10-x-2-x-12-inch-pack-of-100-pc' },
      { name:'10.5 × 8 × 3" Box',        dims:[10.50,8.00,3.00], price:1717, old:2010, url:'/products/10-5-x-8-x-3' },
      { name:'10.5 × 2 × 7.75" Box',     dims:[10.50,2.00,7.75], price:1641, old:1920, url:'/products/10-5-x-2-x-7-75' },
      { name:'11 × 6 × 3" Box',          dims:[11.00,6.00,3.00], price:2033, old:2380, url:'/products/11x-6x-3inch-pack-of-100-pc-copy' },
      { name:'11 × 7.5 × 4" Box',        dims:[11.00,7.50,4.00], price:2848, old:3330, url:'/products/11-x-7-5-x-4' },
      { name:'11 × 8 × 4.5" Box',        dims:[11.00,8.00,4.50], price:1943, old:2275, url:'/products/11-8-4-5' },
      { name:'11 × 8 × 6.75" Box',       dims:[11.00,8.00,6.75], price:2230, old:2610, url:'/products/11-x-8-x-6-75' },
      { name:'11.5 × 3 × 2" Box',        dims:[11.50,3.00,2.00], price:812,  old:950,  url:'/products/11-5-x-2-x-3' },
      { name:'12 × 6 × 2" Box',          dims:[12.00,6.00,2.00], price:1621, old:1895, url:'/products/12-x-6-x-2-inch-pack-of-100-pc' },
      { name:'12 × 8 × 5" Box',          dims:[12.00,8.00,5.00], price:3715, old:4345, url:'/products/12-x-8-x-5-inch-pack-of-100-pc' },
      { name:'12 × 10 × 1.75" Box',      dims:[12.00,10.00,1.75], price:2039, old:2385, url:'/products/12-x-10-x-1-75' },
      { name:'12 × 10 × 3" Box',         dims:[12.00,10.00,3.00], price:2950, old:3450, url:'/products/12-x-10-x-3' },
      { name:'12 × 10 × 5" Box',         dims:[12.00,10.00,5.00], price:4136, old:4840, url:'/products/12-x-10-x-5-inch-pack-of-100-pc' },
      { name:'13 × 13 × 2" Box',         dims:[13.00,13.00,2.00], price:2663, old:3115, url:'/products/13-x-13-x-2-inch-pack-of-100-pc' },
      { name:'14 × 10 × 5" Box',         dims:[14.00,10.00,5.00], price:4365, old:5110, url:'/products/14-x-10-x-5-inch-pack-of-100-pc' },
      { name:'14 × 13 × 3" Box',         dims:[14.00,13.00,3.00], price:3360, old:3930, url:'/products/14-x-13-x-3-inch-pack-of-100-pc' },
      { name:'14 × 14 × 2" Box',         dims:[14.00,14.00,2.00], price:2915, old:3410, url:'/products/14-x-14-x-2-inch-pack-of-100-pc' },
      { name:'16 × 14 × 5" Box',         dims:[16.00,14.00,5.00], price:5540, old:6245, url:'/products/16-x-14-x-5-inch-pack-of-100-pc' },
      { name:'18 × 17.5 × 3" Box',       dims:[18.00,17.50,3.00], price:4950, old:5790, url:'/products/18-x-17-5-x-3' },
      { name:'22 × 10 × 4" Box',         dims:[22.00,10.00,4.00], price:4451, old:5210, url:'/products/22-x-10-x-4-inch-pack-of-100-pc' },
      { name:'3 × 3 × 11" Box',          dims:[3.00,3.00,11.00], price:975,  old:1140, url:'/products/3-x-3-x-11-inch-bottle-packaging' },
      { name:'2.5 × 2.25 × 14" Box',     dims:[2.50,2.25,14.00], price:1120, old:1310, url:'/products/2-5-x-2-25-x-14-inch-pack-of-100pc' }
    ];

    document.querySelectorAll('.pp-finder').forEach(function(root) {
      var PADDING = parseFloat(root.getAttribute('data-padding')) || 0.5;
      var CUSTOM_URL = root.getAttribute('data-custom-url') || '/pages/customise-your-box';
      var TOUR_KEY = 'pp_size_finder_tour_v2';
      var currentUnit = 'in';
      function $(sel)  { return root.querySelector(sel); }
      function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      function fmtINR(n) { return '₹ ' + Math.round(n).toLocaleString('en-IN'); }

      $$('.pp-unit-toggle__btn').forEach(function(b) {
        b.addEventListener('click', function() {
          var unit = b.getAttribute('data-unit');
          if (unit === currentUnit) return;
          var factor = unit === 'cm' ? 2.54 : 1 / 2.54;
          $$('.pp-dim-input').forEach(function(el) {
            var v = parseFloat(el.value);
            if (!isNaN(v) && v > 0) el.value = (v * factor).toFixed(1);
          });
          currentUnit = unit;
          $$('[data-unit-label]').forEach(function(el) { el.textContent = unit; });
          $$('.pp-unit-toggle__btn').forEach(function(x) {
            x.classList.toggle('pp-active', x.getAttribute('data-unit') === unit);
          });
        });
      });

      $$('.pp-qbtn').forEach(function(b) {
        b.addEventListener('click', function() {
          var factor = currentUnit === 'cm' ? 2.54 : 1;
          $('[data-dim="l"]').value = (parseFloat(b.getAttribute('data-l')) * factor).toFixed(1);
          $('[data-dim="w"]').value = (parseFloat(b.getAttribute('data-w')) * factor).toFixed(1);
          $('[data-dim="h"]').value = (parseFloat(b.getAttribute('data-h')) * factor).toFixed(1);
          findBoxes();
        });
      });

      $('[data-action="find"]').addEventListener('click', findBoxes);
      $$('.pp-dim-input').forEach(function(el) {
        el.addEventListener('keydown', function(e) { if (e.key === 'Enter') findBoxes(); });
      });

      function findBoxes() {
        var l = parseFloat($('[data-dim="l"]').value);
        var w = parseFloat($('[data-dim="w"]').value);
        var h = parseFloat($('[data-dim="h"]').value);
        var results = $('[data-results]');
        if (isNaN(l) || isNaN(w) || isNaN(h) || l <= 0 || w <= 0 || h <= 0) {
          results.innerHTML = '<div class="pp-empty">Please enter all three dimensions (L, W and H) above.</div>';
          results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }
        if (currentUnit === 'cm') { l /= 2.54; w /= 2.54; h /= 2.54; }

        var itemSorted = [l, w, h].sort(function(a, b) { return b - a; });

        var scored = BOXES.map(function(box) {
          var boxSorted = box.dims.slice().sort(function(a, b) { return b - a; });
          var slack = boxSorted.map(function(d, i) { return d - itemSorted[i]; });
          var fits = slack.every(function(s) { return s >= -0.05; });
          var minSlack = Math.min.apply(null, slack);
          var totalSlack = slack.reduce(function(a, b) { return a + b; }, 0);
          var exact = slack.every(function(s) { return Math.abs(s) < 0.15; });

          var category;
          if (!fits) { category = 'no'; }
          else if (exact) { category = 'exact'; }
          else if (minSlack >= PADDING * 2 && totalSlack <= 4.5) { category = 'perfect'; }
          else if (minSlack < PADDING * 2) { category = 'snug'; }
          else { category = 'roomy'; }
          var score = exact ? -1 : totalSlack;
          return { box: box, slack: slack, category: category, score: score };
        }).filter(function(r) { return r.category !== 'no'; })
          .sort(function(a, b) { return a.score - b.score; });

        renderResults(scored.slice(0, 3), { l: l, w: w, h: h });
      }

      function renderResults(top, item) {
        var box = $('[data-results]');
        if (!top.length) {
          box.innerHTML =
            '<h2>No standard box fits this item</h2>' +
            '<p class="pp-resub">Your item is larger than our stock sizes. ' +
            '<a href="' + CUSTOM_URL + '" style="color:#8a541b;font-weight:600;">Order a custom box →</a></p>';
          return;
        }
        var dimStr = item.l.toFixed(1) + ' × ' + item.w.toFixed(1) + ' × ' + item.h.toFixed(1) + '"';
        var topCat = top[0].category;
        var summary = topCat === 'exact'   ? 'We found an exact match.' :
                      topCat === 'perfect' ? 'Top pick has ½" or more of padding on every side.' :
                      topCat === 'snug'    ? 'Smallest boxes that fit your item — least wasted space, lowest shipping cost. For fragile items, pick a roomier option below.' :
                                             'Smallest boxes that fit your item with some room around it.';

        var labels = ['Longest', 'Middle', 'Shortest'];
        var cards = top.map(function(r, i) {
          var fitClass = 'pp-fit pp-fit--' + r.category;
          var fitLabel = r.category === 'exact'   ? '★ Exact size match' :
                         r.category === 'perfect' ? '✓ Good fit (½"+ padding)' :
                         r.category === 'snug'    ? '✓ Snug fit (minimal waste)' :
                                                    'ℹ Roomy fit';
          var oldHtml = r.box.old ? ' <span class="pp-old">₹ ' + r.box.old.toLocaleString('en-IN') + '</span>' : '';
          var slackHtml = r.slack.map(function(s, ix) {
            var note = s < 0.05 ? 'exact' : '+' + s.toFixed(1) + '" spare';
            return labels[ix] + ': ' + note;
          }).join(' · ');
          var showCrown = (i === 0);
          var crownLabel = r.category === 'exact'   ? 'EXACT MATCH' :
                           r.category === 'perfect' ? 'BEST FIT' :
                           r.category === 'snug'    ? 'CLOSEST FIT' :
                                                      'BEST FIT';
          return ''
            + '<div class="pp-rec' + (showCrown ? ' pp-rec--best' : '') + '">'
            +   (showCrown ? '<div class="pp-rec__crown">' + crownLabel + '</div>' : '')
            +   '<div class="pp-rec__icon">📦</div>'
            +   '<div class="' + fitClass + '">' + fitLabel + '</div>'
            +   '<p class="pp-rec__name">' + r.box.name + '</p>'
            +   '<p class="pp-rec__dim">Box: ' + r.box.dims[0] + ' × ' + r.box.dims[1] + ' × ' + r.box.dims[2] + '"</p>'
            +   '<p class="pp-rec__slack">' + slackHtml + '</p>'
            +   '<p class="pp-rec__price">' + fmtINR(r.box.price) + oldHtml + '</p>'
            +   '<a class="pp-rec__btn" href="' + r.box.url + '">View product →</a>'
            + '</div>';
        }).join('');
        box.innerHTML =
          '<h2>Recommended boxes for your ' + dimStr + ' item</h2>' +
          '<p class="pp-resub">' + summary + '</p>' +
          '<div class="pp-rec-grid">' + cards + '</div>';
        box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        var recEls = box.querySelectorAll('.pp-rec');
        top.forEach(function(r, i) {
          fetch(r.box.url + '.js')
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(function(data) {
              if (!data || !data.featured_image) return;
              var iconEl = recEls[i] && recEls[i].querySelector('.pp-rec__icon');
              if (!iconEl) return;
              var src = data.featured_image.replace(/^https?:/, '').replace(/\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i, '_300x.$1$2');
              iconEl.innerHTML = '<img src="' + src + '" alt="" loading="lazy" />';
              iconEl.classList.add('pp-rec__icon--img');
            })
            .catch(function() {});
        });
      }

      function startTour() {
        if (!window.driver || !window.driver.js) return setTimeout(startTour, 200);
        var drv = window.driver.js.driver({
          showProgress: true, animate: true, allowClose: true,
          popoverClass: 'pp-themed',
          progressText: 'Step {{current}} of {{total}}',
          nextBtnText: 'Next →', prevBtnText: '← Back', doneBtnText: 'Got it',
          steps: [
            { element: root.querySelector('[data-tour="howto"]'),
              popover: { title: 'Step 1 · Measure your item',
                description: 'Measure your item’s <b>Length, Width and Height</b> at the widest points.',
                side: 'top' } },
            { element: root.querySelector('[data-tour="dims"]'),
              popover: { title: 'Step 2 · Enter the dimensions',
                description: 'Type the L, W and H. Don’t know exact numbers? Tap one of the <b>common items</b> below.',
                side: 'bottom' } },
            { element: root.querySelector('[data-tour="findbtn"]'),
              popover: { title: 'Step 3 · See your size',
                description: 'Tap <b>Find my box size</b>. We’ll show the boxes that fit, with a clear label for each.',
                side: 'bottom' } }
          ]
        });
        drv.drive();
      }
      root.querySelector('[data-action="tour"]').addEventListener('click', startTour);

      try {
        if (!localStorage.getItem(TOUR_KEY)) {
          setTimeout(function() { startTour(); localStorage.setItem(TOUR_KEY, '1'); }, 600);
        }
      } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
